import { useState, useRef, useEffect, useCallback, useMemo } from 'react';
import {
  Box,
  FormControl,
  Select,
  MenuItem,
  Snackbar,
  Alert,
} from '@material-ui/core';
import ErrorIcon from '@material-ui/icons/Error';
import dayjs from 'dayjs';
// import TooltipML from '../../user_behavior_detail/components/Tooltip';
import SvgIconML from '@/components/SvgIconML/SvgIconML';
import DateRangePickerML from '@/components/DateRangePickerML';
import webStorage from '@/utils/storageManager';
import { useDispatch, useSelector } from 'dva';
import { useLocation, history } from 'umi';
import qs from 'qs';
import { TreeSelect } from 'antd';
import TablePage from '../components/table_page/TablePage';
import TBarML from './TBarML';
import { TreeSelectStyled } from './TreeSelectStyled';

export default () => {
  const location = useLocation();
  const { query, pathname } = location;
  const { pageNum = '1', pageSize = '5' } = query;
  const boxRef = useRef();
  const dispatch = useDispatch();
  const today = dayjs();
  const sixDaysAgo = today.subtract(6, 'day');
  const { TRACKING_COMPARE_TYPE } = webStorage.get('DICTOBJ') || {};
  const { SHOW_PARENT } = TreeSelect;

  const loading = useSelector((state) => state.loading).effects[
    'behaviorData/queryTrackingLogList'
  ];

  const { dataBehaveCompareList, trackIngObjectList } =
    useSelector((state) => state.behaviorData) || {};
  let { behaveList, totalUser, num } = dataBehaveCompareList || {};

  const { total } = behaveList || {};

  const [filterType, setFilterType] = useState('DAY_RATIO'); //DAY_RATIO //CUSTOM_RATIO
  const [eventType, setEventType] = useState();
  const [dataType, setDataType] = useState('chart');
  const [date, setDate] = useState({ startDate: sixDaysAgo, endDate: today });
  const [alertOpen, setAlertOpen] = useState(false);
  const [triangle, setTriangle] = useState(false);

  //查询事件类型下拉框
  const queryTrackIngObjectList = useCallback(() => {
    dispatch({
      type: 'behaviorData/queryTrackIngObjectList',
      payload: {},
    });
  }, [dispatch]);

  //行为数据统计对比
  const queryDataBehaveCompare = useCallback(() => {
    !triangle &&
      dispatch({
        type: 'behaviorData/queryDataBehaveCompare',
        payload: {
          startDate:
            filterType === 'CUSTOM_RATIO' && date.startDate
              ? dayjs(date.startDate).format('YYYY-MM-DD')
              : null,
          endDate:
            filterType === 'CUSTOM_RATIO' && date.endDate
              ? dayjs(date.endDate).format('YYYY-MM-DD')
              : null,
          dateType: filterType,
          eventType,
        },
      });
  }, [date.endDate, date.startDate, dispatch, filterType, eventType, triangle]);

  //行为事件统计对比列表
  const queryDataBehaveCompareList = useCallback(() => {
    if (dataType === 'table') {
      dispatch({
        type: 'behaviorData/queryDataBehaveCompareList',
        payload: {
          startDate:
            date.startDate && dayjs(date.startDate).format('YYYY-MM-DD'),
          endDate: date.endDate && dayjs(date.endDate).format('YYYY-MM-DD'),
          eventType,
          pageNum,
          pageSize,
        },
      });
    }
  }, [
    dataType,
    date.endDate,
    date.startDate,
    dispatch,
    eventType,
    pageNum,
    pageSize,
  ]);

  //下载行为事件统计列表
  const downloadTrackingListData = useCallback(() => {
    dispatch({
      type: 'behaviorData/downLoadBehaveCompareList',
      payload: {
        pageNum: 1,
        pageSize: 100000000,
        eventType,
        startDate: dayjs(date.startDate).format('YYYY-MM-DD'),
        endDate: dayjs(date.endDate).format('YYYY-MM-DD'),
        dateType: filterType,
      },
      callback: () => {
        setAlertOpen(true);
      },
    });
  }, [date.endDate, date.startDate, dispatch, filterType, eventType]);

  useEffect(() => {
    queryTrackIngObjectList();
  }, [queryTrackIngObjectList]);

  useEffect(() => {
    queryDataBehaveCompare();
  }, [queryDataBehaveCompare]);

  useEffect(() => {
    queryDataBehaveCompareList();
  }, [queryDataBehaveCompareList]);

  const handleChange = (v) => {
    dispatch({
      type: 'behaviorData/save',
      payload: {
        filterType: v.target.value,
      },
    });
    setDataType(v.target.value === 'CUSTOM_RATIO' ? 'table' : 'chart');
    setFilterType(v.target.value);
  };

  const handleChangeEvent = (v) => {
    setEventType(v);
  };
  const handleDateChange = (value) => {
    setDate(value);
  };
  const handleDownloadData = () => {
    if (filterType !== 'CUSTOM_RATIO') {
      return false;
    }
    downloadTrackingListData();
  };
  const handleCheckData = (type) => {
    if (filterType !== 'CUSTOM_RATIO') {
      return false;
    }
    setDataType(type);
  };

  useEffect(() => {
    return () => {
      dispatch({
        type: 'behaviorData/save',
        payload: {
          filterType: 'DAY_RATIO',
          xData: [],
          data: [],
          dataBehaveCompare: {},
        },
      });
    };
  }, [dispatch]);

  // 翻页事件处理
  const handlePageChange = (p) => {
    history.replace(
      `${pathname}?${qs.stringify({
        ...query,
        pageNum: p.pageNum,
        pageSize: p.pageSize,
      })}`,
    );
  };

  const arrayMap = useCallback((arr) => {
    return arr?.map((item) => {
      const itemNew = item;
      itemNew.title = itemNew.name;
      itemNew.key = itemNew.id;
      itemNew.value = itemNew.id;
      itemNew?.children && arrayMap(itemNew?.children);
      return itemNew;
    });
  }, []);

  const eventList = useMemo(() => {
    return arrayMap(trackIngObjectList);
  }, [arrayMap, trackIngObjectList]);

  const tProps = {
    treeData: eventList,
    value: eventType,
    onChange: handleChangeEvent,
    treeCheckable: true,
    showCheckedStrategy: SHOW_PARENT,
    placeholder: '请选择',
    style: {
      width: '100%',
    },
    bordered: false,
    maxTagCount: 1,
    maxTagTextLength: 11,
    treeExpandAction: 'click',
    nodeSelectedBg: '#fff',
    nodeHoverBg: '#fff',
    onFocus: () => {
      setTriangle(true);
    },
    onBlur: () => {
      setTriangle(false);
    },
  };

  const handleClose = () => {
    setAlertOpen(false);
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
        <Box display="flex" flex="1">
          行为事件统计
          {/* <TooltipML info="这里是一段文字描述" /> */}
        </Box>
        <Box sx={{ display: 'flex', gap: '24px', alignItems: 'center' }}>
          <Box sx={{ display: 'flex' }}>
            <div
              style={{
                padding: '2px 2px 2px 4px',
                border:
                  filterType !== 'CUSTOM_RATIO'
                    ? '1px solid  #ccc'
                    : filterType === 'CUSTOM_RATIO' && dataType === 'table'
                    ? '1px solid rgb(21,101,192)'
                    : '1px solid #333',
                borderRight:
                  filterType !== 'CUSTOM_RATIO'
                    ? '1px solid  #ccc'
                    : filterType === 'CUSTOM_RATIO' && dataType === 'table'
                    ? '1px solid  rgb(21,101,192)'
                    : 'none',
                display: 'flex',
                alignItems: 'center',
                cursor: filterType !== 'CUSTOM_RATIO' ? 'no-drop' : 'default',
              }}
              onClick={() => handleCheckData('table')}
            >
              <SvgIconML
                name={'mingxi'}
                size={16}
                fill={
                  filterType !== 'CUSTOM_RATIO'
                    ? '#ccc'
                    : filterType === 'CUSTOM_RATIO' && dataType === 'table'
                    ? 'rgb(21,101,192)'
                    : '#333'
                }
              ></SvgIconML>
            </div>
            <div
              style={{
                padding: '2px 4px 2px 2px',
                border:
                  filterType !== 'CUSTOM_RATIO'
                    ? '1px solid  #ccc'
                    : filterType === 'CUSTOM_RATIO' && dataType !== 'table'
                    ? '1px solid rgb(21,101,192)'
                    : '1px solid #333',
                borderLeft:
                  filterType !== 'CUSTOM_RATIO'
                    ? '1px solid  #ccc'
                    : filterType === 'CUSTOM_RATIO' && dataType !== 'table'
                    ? '1px solid #333'
                    : 'none',
                display: 'flex',
                alignItems: 'center',
                cursor: filterType !== 'CUSTOM_RATIO' ? 'no-drop' : 'default',
              }}
              onClick={() => handleCheckData('chart')}
            >
              <SvgIconML
                name={'chart'}
                size={16}
                fill={
                  filterType !== 'CUSTOM_RATIO'
                    ? '#ccc'
                    : filterType !== 'DAY_RATIO' && dataType !== 'table'
                    ? 'rgb(21,101,192)'
                    : '#333'
                }
              ></SvgIconML>
            </div>
          </Box>
          <Box
            sx={{
              display: 'flex',
              gap: '8px',
              alignItems: 'center',
              color: filterType === 'CUSTOM_RATIO' ? 'rgb(21,101,192)' : '#ccc',
              cursor: dataType === 'default' ? 'no-drop' : '#ccc',
            }}
            onClick={handleDownloadData}
          >
            <SvgIconML
              name={'favorite_border'}
              size={16}
              fill={filterType === 'CUSTOM_RATIO' ? 'rgb(21,101,192)' : '#ccc'}
            ></SvgIconML>
            下载报表
          </Box>
        </Box>
      </Box>

      <Box sx={{ display: 'flex', gap: '24px', marginTop: '24px' }}>
        <FormControl sx={{ height: 'auto', width: '120px' }}>
          <Select
            value={filterType}
            onChange={handleChange}
            variant="standard"
            sx={{ height: 'auto' }}
          >
            {TRACKING_COMPARE_TYPE?.map((item) => (
              <MenuItem value={item.dictCode} key={item.dictCode}>
                {item.nameZh}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        {filterType === 'CUSTOM_RATIO' && (
          <FormControl variant="standard">
            <DateRangePickerML
              label="开始时间"
              title="结束时间"
              afterDays="30"
              startText=""
              endText=""
              defaultStartDate={date.startDate}
              defaultEndDate={date.endDate}
              setValue={setDate}
              onChange={handleDateChange}
              name="custom-form-submit-name"
            />
          </FormControl>
        )}
        <FormControl sx={{ height: 'auto', width: '240px' }}>
          <TreeSelectStyled>
            <TreeSelect
              {...tProps}
              suffixIcon={
                <SvgIconML
                  name="arrow-drop-down"
                  size={10}
                  fill="#1565c0"
                  className="preview"
                />
              }
            />

            <Box className="triangle">
              <SvgIconML
                name="arrow-drop-up"
                className={triangle ? 'arrow_down' : 'arrow_up'}
                size={10}
              />
            </Box>
          </TreeSelectStyled>
        </FormControl>
      </Box>

      <Box height="100%" ref={boxRef}>
        {dataType === 'table' ? (
          <Box
            sx={{ display: 'flex', flexDirection: 'column', flex: 1 }}
            height="100%"
          >
            <Box
              sx={{
                display: 'flex',
                color: '#000',
                marginTop: '20px',
                fontWeight: '600',
              }}
            >
              <Box sx={{ display: 'flex', flex: 1 }}>
                <Box
                  display="flex"
                  flex="1"
                  sx={{
                    justifyContent: 'center',
                    backgroundColor: '#f5f5f5',
                    height: '48px',
                    alignItems: 'center',
                  }}
                >
                  总用户量
                </Box>
                <Box
                  display="flex"
                  flex="1"
                  sx={{ justifyContent: 'center', alignItems: 'center' }}
                >
                  {totalUser || 0}
                </Box>
              </Box>
              <Box sx={{ display: 'flex', flex: 1 }}>
                <Box
                  sx={{
                    display: 'flex',
                    flex: '1',
                    backgroundColor: '#f5f5f5',
                    justifyContent: 'center',
                    alignItems: 'center',
                  }}
                >
                  行为事件数量
                </Box>
                <Box
                  display="flex"
                  flex="1"
                  sx={{ justifyContent: 'center', alignItems: 'center' }}
                >
                  {num || 0}
                </Box>
              </Box>
            </Box>
            <TablePage
              pagination={{
                pageNum,
                pageSize,
              }}
              loading={loading}
              total={total}
              tableData={behaveList?.data || []}
              setPageData={handlePageChange}
            />
          </Box>
        ) : (
          <TBarML height={boxRef?.current?.clientHeight || 0} />
        )}
      </Box>
      <Snackbar
        open={alertOpen}
        autoHideDuration={2000}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'top', horizontal: 'top' }}
      >
        <Alert
          severity="info"
          sx={{
            width: '419px',
            backgroundColor: '#E5F6FD',
            fontSize: '14px',
            lineHeight: '22px',
          }}
          iconMapping={{
            info: <ErrorIcon fontSize="inherit" sx={{ color: '#2094D6' }} />,
          }}
        >
          数据下载中，可在我的任务查看导出结果
        </Alert>
      </Snackbar>
    </Box>
  );
};
